/**
 * 升级公告内容维护模块
 * 创建时间：2017-07-10
 * 创建人：baixx
 */
<template>
		<div id="version-list" class="wrapper wrapper-content fadeInRight animated tabBox">
		   <div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">版本时间</label>
					<div class="col-sm-3">
					    <datepicker v-model="queryParam.versionDate" class="form-control" ref="dateFrom"></datepicker>
				    </div>
					<label class="col-sm-1 control-label">版本名称</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="queryParam.versionName" maxlength="20">
					</div>
					<label class="col-sm-1 control-label">系统平台</label>
					<div class="col-sm-3">
						<!--<input class="form-control" v-model.trim="queryParam.source" maxlength="10">-->
						<select class="form-control" v-model="queryParam.systemTypes">
							<option v-for="(option, index) in systemTypeList" v-bind:value="option.udccode" :key="'system' + index">
								{{option.udcname}}
							</option>
						</select>
					</div>
				</div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
						<button class="btn btn-primary" @click="searchInfo">查询</button>
						<button class="btn btn-primary" @click="resetQueryParams">重置</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
				    	<button class="btn btn-primary" @click="addVersion">新建</button>
					</div>
				</div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th>系统</th>
							<th>版本时间</th>
							<th>版本名称</th>
							<th></th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(fileInfo,index) in fileInfoList" v-bind:key="'versionHistory' + index">
							<td>{{fileInfo.udcName}}</td>
							<td>{{fileInfo.versionDate}}</td>
							<td>{{fileInfo.versionName}}</td>
							<td class="text-center"><a @click="editVersion(index)">编辑&nbsp;</a>

								 <a @click="removeVersion(index)">&nbsp;删除</a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			<pagination v-if="fileInfoList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			</div>
			<sub-page :show="showSubPage"
			:bigTitleMsg="noticeTitle"
			v-on:cancel="closeSubPage"
			:scroll="scrollTop">
			<div slot="bodycontent">
				<page-versionHistory-edit
					:data="detailInfo"
					:model="model"
					:udccode="udccode"
					v-on:cancel="closeSubPage"
					v-on:handleSave="saveSubPage">
				</page-versionHistory-edit>
			</div>
		    </sub-page>
		    <!--SubPage组件弹框开始-->
		    <tab-modal ref="modalConfirm" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="withdrawSubBtn">取消</button>
				<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
			</div>
	    	</tab-modal>
		   	<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
</template>

<script>
    import Pagination from 'components/common/Pagination'
    import TabModal from 'components/common/TabModal'
    import SubPage from 'components/common/SubPage'
    import Datepicker from 'components/common/datepicker/Datepicker'
    import { OPERATE_EXCEPTION } from 'static/message'
    import {DICTIONARY_MAP} from 'static/constant'
    import {getDictionaryFromArray} from 'util/util'
    import classlist from 'util/classlist'
    import PageVersionHistoryEdit from 'components/pages/versionhistory/PageVersionHistoryEdit'
export default {
  name: 'PageVersionHistoryList',
  components: {
        PageVersionHistoryEdit,
        Pagination,
        TabModal,
        SubPage,
        Datepicker
  },
  data () {
        return {
          fileInfoList: [],										// 查询结果
          pageInfo: {},
          detailInfo: {},
          udccode: '',
          queryParam: {
            source: '',										   // 系统
            versionDate: '',							       // 版本时间
            versionName: '',                                   // 版本名称
            versionContent: '',                                   // 版本说明
            page_index: 1,
            systemTypeList: ''                                    // 系统平台类型分组
          },
          loadingstatus: false,
          model: '',
          showSubPage: false,
          messageStr: '',					                        // 弹出框内容
          scrollTop: '0',
          noticeTitle: '',
          indexNo: '',
          systemTypeList: []
        }
  },
  beforeMount () {
			// 初始化信息
        this.getTableInfo()
        this.getUdc()
  },

  methods: {
			// 查询方法
        searchInfo () {
          this.queryParam.page_index = 1
          this.getTableInfo()
        },
			// 初始化信息
        getTableInfo: function () {
          this.loadingstatus = true
          this.$http.get(process.env.API_ROOT + '/version/versions', {params: this.queryParam})
				.then(res => {
  if (res.body.success) {
        const resInfo = res.body.data
        const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
        this.pageInfo = {
          pageNum: pageNum,
          pages: pages,
          total: total,
          isFirstPage: isFirstPage,
          isLastPage: isLastPage
        }
        this.fileInfoList = resInfo.list
        this.loadingstatus = false
  } else {
        this.openModalMsg(res.body.message)
        this.loadingstatus = false
  }
}, res => {
  this.openModalMsg(res.body.message)
  this.loadingstatus = false
}).catch(res => {
  this.openModalMsg(OPERATE_EXCEPTION)
  this.loadingstatus = false
})
        },
			// 增加版本
        addVersion () {
          this.model = '0'
          this.noticeTitle = '公告维护新建'
          this.showSubPage = true
          this.detailInfo = {}
          classlist.toggleScroll('close', '#version-list', this)
        },
			// 编辑版本
        editVersion (index) {
          this.model = '1'
          this.noticeTitle = '公告维护编辑'
			    this.detailInfo = Object.assign({}, this.fileInfoList[index])
			    this.udccode = this.fileInfoList[index].sysSource
          this.showSubPage = true
          classlist.toggleScroll('close', '#version-list', this)
        },
			// 删除版本
        removeVersion (index) {
          this.indexNo = index
          this.messageStr = '确定要删除此版本吗'
          this.$refs.modalConfirm.open()
        },
			// 取消删除版本
        withdrawSubBtn () {
          this.$refs.modalConfirm.close()
        },
			// 删除版本
        confirmSubBtn () {
          this.$refs.modalConfirm.close()
          this.loadingstatus = true
          this.$http.delete(process.env.API_ROOT + '/version/versions/', {body: [this.fileInfoList[this.indexNo].id]})
				.then(res => {
  if (res.data.success) {
        this.getTableInfo()
        this.loadingstatus = false
  } else {
        this.openModalMsg(res.data.message)
        this.loadingstatus = false
  }
}, res => {
  this.openModalMsg(res.data.message)
  this.loadingstatus = false
}).catch(res => {
  this.openModalMsg(OPERATE_EXCEPTION)
  this.loadingstatus = false
})
        },
			// 从分页组件获取页码参数
        getPageNo (pageNo) {
          this.queryParam.page_index = pageNo
          this.getTableInfo()
        },
			// 关闭升级公告
        closeSubPage () {
          this.showSubPage = false
          classlist.toggleScroll('open', '#version-list', this)
        },
			// 保存升级公告成功
        saveSubPage () {
          this.showSubPage = false
          this.getTableInfo()
          classlist.toggleScroll('open', '#version-list', this)
        },

			// 消息弹出框相关
        openModal (ref) {
            	this.$refs[ref].open()
        	classlist.toggleScroll('close', '#version-list', this)
        },
        	closeModal (ref) {
        		this.$refs[ref].close()
    		 classlist.toggleScroll('open', '#version-list', this)
        },
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        },
        	openModalMsg (message) {
        		this.messageStr = message
          this.openModal('modalMsg')
        	},
        	// 获取数据字典
        	getUdc () {
        		let udcType = [
					 DICTIONARY_MAP.SYSTEM_TYPE
        ]
          let param = udcType.join(',')
          this.$http.get(process.env.API_ROOT + '/system/udcs', {params: {udcTypes: param}})
				.then(res => {
  if (res.body.success) {
					 	this.systemTypeList = getDictionaryFromArray(res.body.data, DICTIONARY_MAP.SYSTEM_TYPE)
  } else {
						// this.openModalMsg(res.data.message);
  }
}, res => {
					// this.openModalMsg(res.data.message);
}).catch(res => {
					// this.openModalMsg(OPERATE_EXCEPTION);
})
        	},
        	// 重置
        resetQueryParams: function () {
          this.$refs.dateFrom.handleClear()
          this.queryParam = {
            source: '',					           // 系统
            versionName: '',			               // 版本名称
            page_index: 1
          }
		    }
      }
}
</script>



// WEBPACK FOOTER //
// PageVersionHistoryList.vue?2d7d24f4